// PaymentReturn.js — route: /payment/return
// JazzCash payment complete hone ke baad backend patient ko yahan bhejta hai:
//   /payment/return?status=success&appointment_id=12
//   /payment/return?status=failed&appointment_id=12
import React, { useEffect, useState, useContext } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { AppContext } from '../../context/AppContext';

const PaymentReturn = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { baseUrl } = useContext(AppContext);
  const patientToken = localStorage.getItem('patient_token');

  const [loading, setLoading]         = useState(true);
  const [appointment, setAppointment] = useState(null);
  const status = searchParams.get('status');
  const appointmentId = searchParams.get('appointment_id');

  useEffect(() => {
    if (!appointmentId) { setLoading(false); return; }

    axios.get(`${baseUrl}/Patient/Booking/${appointmentId}/status`, {
      headers: {
        Authorization: `Bearer ${patientToken}`,
        Accept: 'application/json',
      },
    })
      .then((res) => setAppointment(res.data.data))
      .catch((err) => console.error('Status fetch error:', err))
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appointmentId, baseUrl]);

  if (loading) {
    return <div style={{ textAlign: 'center', padding: '4rem' }}>Confirming payment status...</div>;
  }

  const isSuccess = status === 'success' && appointment?.payment_status === 'paid';

  return (
    <div style={{ maxWidth: 480, margin: '3rem auto', padding: '2rem', textAlign: 'center', borderRadius: 16, boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }}>
      {isSuccess ? (
        <>
          <div style={{ fontSize: '3rem' }}>✅</div>
          <h2 style={{ color: '#00005a' }}>Payment Successful</h2>
          <p style={{ color: '#64748B' }}>
            Aapki appointment book ho gayi hai. Therapist ki taraf se confirmation
            ka intezaar karein.
          </p>
        </>
      ) : (
        <>
          <div style={{ fontSize: '3rem' }}>❌</div>
          <h2 style={{ color: '#B91C1C' }}>Payment Failed</h2>
          <p style={{ color: '#64748B' }}>
            Payment complete nahi ho saka. Aapka slot release kar diya gaya hai,
            aap dobara try kar sakte hain.
          </p>
        </>
      )}
      <button
        onClick={() => navigate('/patient/dashboard')}
        style={{ marginTop: '1.5rem', padding: '0.75rem 2rem', borderRadius: 999, background: '#FF8C00', color: 'white', border: 'none', fontWeight: 700, cursor: 'pointer' }}
      >
        Go to Dashboard
      </button>
    </div>
  );
};

export default PaymentReturn;